import { VariantTypes } from '../artworkProcessing';
export var IMAGE_FORMAT;
(function (IMAGE_FORMAT) {
    IMAGE_FORMAT["PNG"] = "Png";
    IMAGE_FORMAT["JPEG"] = "Jpeg";
    IMAGE_FORMAT["WEBP"] = "Webp";
})(IMAGE_FORMAT || (IMAGE_FORMAT = {}));
export const variants = Object.values(VariantTypes);
export const isInfoVariant = (variant) => ['font', 'documentItem', 'storage', 'asset'].includes(variant);
export const isInfoImageVariant = (variant) => ['classifications', 'colors', 'text', 'quality'].includes(variant);
export var AssetStoreFetchStatusType;
(function (AssetStoreFetchStatusType) {
    AssetStoreFetchStatusType["Idle"] = "Idle";
    AssetStoreFetchStatusType["Fetching"] = "Fetching";
    AssetStoreFetchStatusType["Error"] = "Error";
})(AssetStoreFetchStatusType || (AssetStoreFetchStatusType = {}));
/**
 * The `ParamNames` enum maps property names to their shorthand representations, which can be used in stacked variant URLs.
 * Each property has a corresponding short code to simplify usage in query parameters.
 *
 * Examples:
 * - `backgroundDetectMode` can be used as `bdm` in the URL.
 * - `threshold` can be represented as `t`.
 */
export var ParamNames;
(function (ParamNames) {
    ParamNames["classificationType"] = "ct";
    ParamNames["backgroundDetectMode"] = "bdm";
    ParamNames["optimizeSaliencyMask"] = "osm";
    ParamNames["preserveTexture"] = "pt";
    ParamNames["tryFillHoles"] = "tfh";
    ParamNames["enhanceResolution"] = "er";
    ParamNames["newBackgroundUrl"] = "nbu";
    ParamNames["saliencyMap"] = "map";
    ParamNames["saliencyMode"] = "mode";
    ParamNames["requiredWidth"] = "width";
    ParamNames["requiredHeight"] = "height";
    ParamNames["cropMode"] = "m";
    ParamNames["left"] = "l";
    ParamNames["right"] = "r";
    ParamNames["top"] = "t";
    ParamNames["bottom"] = "b";
    ParamNames["threshold"] = "t";
    ParamNames["hexColor"] = "c";
    ParamNames["invertColor"] = "i";
    ParamNames["noOfColors"] = "n";
    ParamNames["output"] = "out";
    ParamNames["processBackgroundColor"] = "pbc";
})(ParamNames || (ParamNames = {}));
//# sourceMappingURL=types.js.map